import React, { Component }  from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import Button from '@material-ui/core/Button';
const { t } = useTranslation();

class HomePage extends Component {
    componentDidMount() {
        this.props.setHeader();
    };

    render() {
        return (
            <div className="ButtonWell"> 
                <NavLink className="navButton" to="/productionOrderIndex">
                    <Button color="secondary" fullWidth variant="contained" ><Trans>{t('ProductionButton')}</Trans></Button>
                </NavLink>
                <NavLink className="navButton" to="/orderHistoryIndex">
                    <Button color="secondary" fullWidth variant="contained" ><Trans>{t('LookupButton')}</Trans></Button>
                </NavLink>
                <NavLink className="navButton" to="/planningIndex">
                    <Button color="secondary" fullWidth variant="contained" ><Trans>{t('PlanningButton')}</Trans></Button>
                </NavLink>
            </div>
        )
    }
}

export default HomePage;